import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { DateField } from "../../../../../../features/forms/fields/date-field/date-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlPreOrderDate = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <DateField
      form={props.form}
      label="Pre-Order Date"
      name="preOrderDate"
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
